import * as LocalStorageManager from './StorageManager';
import HttpService from './HttpService';
import { isDefined } from './Common';

const AuthService = {
    isAuthenticated(){
        return LocalStorageManager.isLoggedIn()
    },
    login(documento, senha, tipoLogin, callback = undefined) {
        HttpService.call(
            'sistema/login',
            'login',
            [
                documento,
                senha,
                tipoLogin
            ],
            (userData) => {
                LocalStorageManager.setLoggedUser(userData);

                if(isDefined(callback)){
                    callback(userData);
                }
            },
            true,
            1000
        )
    },
    authenticate(idtAutenticacao, callback) {
        HttpService.call(
            '',
            'auth',
            [
                idtAutenticacao
            ],
            callback
        )
    }
}

export default AuthService;


// WEBPACK FOOTER //
// ./src/util/Authenticate.js